export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, ``)
    .replace(/[\s_]+/g, `-`)
    .replace(/^-+|-+$/g, ``)
    .slice(0, 60)
}

export function tripSlug(trip: {
  name?: string | null
  destination: string
}): string {
  return slugify(trip.name || trip.destination) || `trip`
}

export function guideSlug(guide: {
  name?: string | null
  destination: string
}): string {
  return slugify(guide.name || guide.destination) || `guide`
}

// Slug for a /destinations/<slug> hub. `slugify` is lossy (lowercases, strips
// punctuation), so we never reverse a slug back to its destination string —
// the destination lookup re-derives this slug for every distinct destination
// and matches on equality, which keeps the round-trip exact.
export function destinationSlug(destination: string): string {
  return slugify(destination) || `destination`
}
